import { OverviewTabsBar } from '@features/ForestOwner/Search/Overview/OverviewTabsBar.tsx'
import { createFileRoute, Outlet, useMatchRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/forestowner/$forestownerId')({
  component: ForestOwnerLayout,
  staticData: {
    breadcrumb: 'Skogeieroversikt',
  },
})

const standaloneRoutes: {
  to: Parameters<ReturnType<typeof useMatchRoute>>[0]['to']
  fuzzy?: boolean
}[] = [
  { to: '/forestowner/$forestownerId/contactpreferences', fuzzy: true },
  { to: '/forestowner/$forestownerId/edit' },
  { to: '/forestowner/$forestownerId/property/$propertyId' },
  { to: '/forestowner/$forestownerId/shareownership/editShareOwnership', fuzzy: true },
  { to: '/forestowner/$forestownerId/property/add' },
  { to: '/forestowner/$forestownerId/sendSMS', fuzzy: true },
  { to: '/forestowner/$forestownerId/property/$propertyId/protected-area/edit' },
  { to: '/forestowner/$forestownerId/property/protected-area/edit' },
]

function ForestOwnerLayout() {
  const matchRoute = useMatchRoute()

  const isStandalone = standaloneRoutes.some(({ to, fuzzy = false }) => matchRoute({ to, fuzzy }))

  return (
    <div>
      {!isStandalone && <OverviewTabsBar />}
      <Outlet />
    </div>
  )
}
